<ng-container *ngTemplateOutlet="language === 'en' ? en : fr " />

<!--TEMPLATES ENGLISH-->
<ng-template #en>
  <div class="td-wb-preferences__agreement-form">
    <h1 class="td-wb-preferences__agreement-form__header">Russell (LSEG) Subscriber Agreement</h1>
    @if (disabled()) {
      <td-wb-notification class="td-wb-preferences-agreements__completed"
                          notificationType="success">
        Copy for "Viewing Purposes only" :
        No action required, this agreement has been accepted. Thank You.
      </td-wb-notification>
    }
    <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">Schedule 2</p>
    <p class="td-wb-preferences__agreement-form--copy-bold">Statement to be signed by Non-Professional Subscribers</p>
    <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">Non-Professional Customer Statement</p>
    <ol class="td-wb-preferences__agreement-form--primary td-wb-preferences__agreement-form--copy">
      <li class="td-wb-preferences__agreement-form--primary-item">
        I confirm that I:
        <ol class="td-wb-ul--basic">
          <li class="td-wb-preferences__agreement-form--secondary-item">
            am subscribing to the service in a personal capacity;
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">
            am not currently registered or qualified as a professional in any national or state exchange, regulatory authority or professional association;
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">
            do not act in any capacity as an investment advisor;
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">
            solely use the service to manage my personal funds; and
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">
            do not redistribute, republish or provide any Data from the service to any third party.
          </li>
        </ol>
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">
        I agree to provide succinct information and/or documents as you may reasonably require in order to confirm the validity of these representations.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">
        I agree to inform you within 7 (seven) days if the circumstances confirmed in this statement should change.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">
        I accept that my use of the Licensor information as a non-professional end user is conditional upon the validity of this statement.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">
        I accept that I may be liable to you for additional fees and charges in the event of any change in circumstances or non-compliance with the terms of this statement.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">
        I accept that the data contained in this statement may be processed, stored for a period of no more than three years and may be accessed for inspection by auditors acting on behalf of your Licensor during the storage period.
      </li>
    </ol>
    @if (disabled()) {
      <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">
        <span>Dated: </span>
        <span [innerText]="selectedAgreementEffectiveDate | tdWbDate: { format: 'DATE_TIME' }"></span>
      </p>
    }
  </div>
</ng-template>

<!--TEMPLATES FRENCH-->
<ng-template #fr>
  <div class="td-wb-preferences__agreement-form">
    <h1 class="td-wb-preferences__agreement-form__header">« LSEG Russell » – Indice Russell du London Stock Exchange Group</h1>
    @if (disabled()) {
      <td-wb-notification class="td-wb-preferences-agreements__completed"
                          notificationType="success">
        Copie pour « À des fins de visualisation seulement » :
        Aucune mesure à prendre, ce contrat a été accepté. Merci.
      </td-wb-notification>
    }
    <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">Annexe 2</p>
    <p class="td-wb-preferences__agreement-form--copy-bold">La déclaration doit être signée par les souscripteurs non professionnels</p>
    <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">Déclaration de client non professionnel</p>
    <ol class="td-wb-preferences__agreement-form--primary td-wb-preferences__agreement-form--copy">
      <li class="td-wb-preferences__agreement-form--primary-item">
        Je confirme que je :
        <ol class="td-wb-ul--basic">
          <li class="td-wb-preferences__agreement-form--secondary-item">
            m’abonne au service à titre personnel;
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">
            ne suis pas actuellement inscrit auprès d’une bourse nationale ou d’État, d’une autorité de réglementation ou d’une association professionnelle ni ne suis admissible à un titre de professionnel;
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">
            n’agis pas à titre de conseiller en placement;
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">
            n’utilise le service que pour gérer mes fonds personnels; et
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item">
            ne redistribue, ne republie ni ne fournit de données du service à un tiers.
          </li>
        </ol>
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">
        J’accepte de fournir des renseignements ou des documents concis si vous le jugez raisonnablement nécessaire pour confirmer la validité de ces déclarations.
      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">
        J’accepte de vous informer dans les sept (7) jours si les circonstances confirmées dans la présente déclaration changent.      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">
        J’accepte que l’utilisation des renseignements du concédant à titre d’utilisateur final non professionnel soit conditionnelle à la validité de cette déclaration.      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">
        Je reconnais que je pourrais être tenu responsable envers vous de frais supplémentaires liés à un changement de situation ou au non-respect des modalités de la présente déclaration.      </li>
      <li class="td-wb-preferences__agreement-form--primary-item">
        J’accepte que les données contenues dans cette déclaration puissent être traitées et conservées pendant une période maximale de trois ans et que les auditeurs agissant au nom de votre concédant puissent y accéder aux fins de vérification pendant cette période.      </li>
    </ol>
    @if (disabled()) {
      <p class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--copy-bold">
        <span>daté : </span>
        <span [innerText]="selectedAgreementEffectiveDate | tdWbDate: { format: 'DATE_TIME' }"></span>
      </p>
    }
  </div>
</ng-template>
